import { render, staticRenderFns } from "./ProductsNew.vue?vue&type=template&id=f5dd2c88&"
import script from "./ProductsNew.vue?vue&type=script&lang=js&"
export * from "./ProductsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fwww%2Fhtml%2Fhelpcenter%2Fweb%2Fsrc%2Fcomponents%2FProductsNew.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./ProductsNew.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports